import loadable from '@loadable/component';
import React from 'react';
import {Text, View} from 'react-native';
import styles from './ValidationError.style';
const SVG = loadable(() => import('../../../imports/svg'));

export default function ValidationError(props) {
  const {containerStyle, errorText} = props;
  return (
    <View style={[styles.errorWrapper, containerStyle]}>
      <Text style={styles.errorText}>{errorText}</Text>
      <SVG name="fieldError" width={15} height={15} />
    </View>
  );
}
